import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc38b264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "editor" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "bottom-block" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("移动端预览")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存模板")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存一下")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("看好了")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("看好了，下一个")
const _hoisted_9 = { class: "preview-dialog" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "模拟移动端显示： 分辨率：360*640"),
  /*#__PURE__*/_createElementVNode("p", null, "实际显示效果请在移动端查看")
], -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { innerHTML: _ctx.content }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "warning",
          onClick: _ctx.showMobie
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        (!_ctx.isWorkbench)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "mini",
              onClick: _ctx.getRichText
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isWorkbench)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "mini",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveOrder(false, false, false)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_ctx.isWorkbench)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "mini",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveOrder(false, false, true)))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isWorkbench)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "mini",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveOrder(true, false, true)))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_dialog, {
        "destroy-on-close": true,
        modelValue: _ctx.isShowPreview,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShowPreview) = $event)),
        title: "移动端预览",
        width: "40%",
        onClosed: _ctx.clearCache
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", null, [
              _createElementVNode("iframe", {
                class: "preview",
                src: _ctx.url,
                sandbox: "allow-forms allow-same-origin allow-top-navigation allow-scripts",
                seamless: "",
                name: "mobiepreview"
              }, "\n          ", 8, _hoisted_11)
            ]),
            _hoisted_12
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"])
    ])
  ], 64))
}